import { Drawer } from "antd";
import { Link } from "react-router-dom";

import ResignationDetailPanel from "./ResignationDetailPanel";

/** The list's detail view. A drawer rather than a page so the list keeps its
 *  filters, page and scroll position while someone works through requests. */
const ResignationDetailDrawer = ({ record, onClose, onChanged }) => (
  <Drawer
    open={!!record}
    onClose={onClose}
    width="min(720px, 100vw)"
    title="Resignation request"
    destroyOnHidden
    extra={
      record && (
        <Link to={`/resignations/${record.id}`} className="table-link small fw-semibold">
          Open full page <i className="las la-external-link-alt" aria-hidden="true" />
        </Link>
      )
    }
  >
    {record && <ResignationDetailPanel key={record.id} id={record.id} summary={record} onChanged={onChanged} />}
  </Drawer>
);

export default ResignationDetailDrawer;
